import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {Subject} from "rxjs";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";
import {TextUtils} from "../../../../../shared/utils/text-utils";
import {first, takeUntil} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {DbStoreState, getWebsite} from "../../../../../store";
import * as fromStore from "../../../../../store";
import {TypeUtils} from "../../../../../shared/utils/type-utils";
import {Router} from "@angular/router";


@Component({
    selector: 'db-cdn-enable-banner',
    templateUrl: './cdn-enable-banner.component.html',
    styleUrls: ['./cdn-enable-banner.component.scss'],
    standalone: false
})
export class CdnEnableBannerComponent implements OnInit, OnDestroy {
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  public options: any;
  public status: any;
  public step: number = 1;
  public isNameServer: boolean;
  @Input() websiteId: number;
  @Input() cloudflareEnabled: boolean;
  @Input() longSize: boolean = false;
  @Input() forHosting: boolean = false;

  constructor(
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _store: Store<DbStoreState>,
    private _router: Router
  ) {}

  ngOnInit() {
    this._setOptions();
    this._getWebsite();
    this._getCFData();
    this._getCFDefaultDnsRecord();
  }

  private _getWebsite(): void {
    this._store.select(getWebsite(this.websiteId))
      .pipe(
        first(website => !!website)
      )
      .subscribe(website => {
        this.cloudflareEnabled = website.cloudflareEnabled;
      });
  }

  private _setOptions(): void {
    this.options = [
      {
        img: "assets/images/icons/speed-green.svg",
        text: TextUtils.getText('text_proOptimCdnOption1'),
      },
      {
        img: "assets/images/icons/speed-time.svg",
        text: TextUtils.getText('text_proOptimCdnOption2'),
      },
      {
        img: "assets/images/icons/speed-globe.svg",
        text: TextUtils.getText('text_proOptimCdnOption3'),
      }
    ];
  }

  private _getCFData(): void {
    this._store.select(fromStore.getCloudflareData(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream$),
      )
      .subscribe((data) => {
        this.step = data && data.txtStatus && data.txtStatus !== 'pending' ? 2 : 1;
        this.status = !TypeUtils.isEmpty(data) && TypeUtils.isDefined(data.cfStatus) && this.cloudflareEnabled ? data.cfStatus : 'not-enabled';
      });
  }

  private _getCFDefaultDnsRecord(): void {
    this._store.select(fromStore.getCloudflareDefaultRecord(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream$))
      .subscribe(data => {
        if (!TypeUtils.isNull(data) && !TypeUtils.isEmpty(data)) {
          this.isNameServer = !!data.tenwebNs;
        }
      });
  }

  public redirect(): void {
    this._sendGoogleAnalytics('Enable Cloudflare continue btn click');
    this._router.navigate([`/websites/${this.websiteId}/booster/cloudflare`],
      { queryParams: { show_enable_dialog: '1' } });
  }

  public enableCdn(): void {
    this._sendGoogleAnalytics('Enable Cloudflare switcher click');
    this._router.navigate([`/websites/${this.websiteId}/booster/cloudflare`],
      { queryParams: { show_enable_dialog: '1' } });
    return;
  }

  private _sendGoogleAnalytics(action): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: action,
      eventLabel: 'Cloudflare',
      websiteId: this.websiteId
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }


}
